import React, { FunctionComponent } from 'react';
import { EventModel } from '@/events/models';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import { AuthenticatedUserModel } from '@/authentication/models';
import Styles from './Styles.module.scss';
import { VenueType } from '@/venues/models';
import { MapView } from '@/events/components/map-view';
import { EventLocation } from '@/events/components/event-location';
import { EventTime } from '@/events/components/event-time';
import { EventDetailsMiscellaneous } from '@/events/components/event-details-miscellaneous';

type Props = {
    onClosingModal: () => void;
};

export const ConfirmingStatus: FunctionComponent<Props> = ({ onClosingModal }) => {
    const selectedEvent = useSelector<RootState, EventModel | undefined>(
        (state) => state.events.selectedEvent
    );

    const authenticatedUser = useSelector<RootState, AuthenticatedUserModel | undefined>(
        (state) => state.authentication.authenticatedUser
    );

    return (
        <div className={Styles.ConfirmingStatus}>
            <div className={`p-0 d-block mt-3`}>
                {selectedEvent?.venue.type === VenueType.IN_PERSON ? (
                    <div className={`w-100 mb-3 ${Styles.EventMapContainer}`}>
                        {selectedEvent && (
                            <MapView
                                events={[selectedEvent]}
                                authenticatedUser={authenticatedUser}
                                onViewDetails={() => {}}
                                onSelectedEvents={() => {}}
                                areEventsClickable={false}
                                customClassname={Styles.CustomInnerMapClass}
                                loadingEvents={false}
                                recordBoundaries={false}
                                showFirstEventLocationOnly
                            />
                        )}
                    </div>
                ) : null}

                <h4 className={`px-0 pb-2 ${Styles.EventTitle}`}>{selectedEvent?.name}</h4>

                <div className={'d-xl-block d-lg-block d-md-block d-sm-none d-none w-100 py-2'} />

                <EventLocation event={selectedEvent as EventModel} />

                <EventTime event={selectedEvent as EventModel} />

                <div
                    className={'d-xl-block d-lg-block d-md-block d-sm-none d-none w-100 pb-4 pt-2'}
                >
                    <div className={Styles.DividerFull} />
                </div>
            </div>

            <EventDetailsMiscellaneous event={selectedEvent as EventModel} />
        </div>
    );
};
